export default {
    data: function () {
        return {
            update: true,
            options: null
        }
    },
    created() {
        this.buildOptions();
    },
    computed: {
        showRemoveAction() {
            return this.value && this.value.length > 0
        }
    },
    methods: {
        filterOptions(option) {
            return true;
        },
        sortOptions(options){
            options.sort(function (a, b) {

                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });
            return options;
        },
        buildOptions() {
            let options = !this.options ? [] : this.options;
            if (this.facet) {
                let facet = this.facet.filter(this.filterOptions);
                for (let i = 0; i < facet.length; i++) {
                    let type = facet[i];
                    let option = options.find(i => i.id === type);

                    if (!option) {
                        option = {
                            id: type,
                            name: this.getOptionName(type)
                        };

                        options.push(option);

                    }
                }

                for (let i = 0; i < options.length; i++) {
                    let option = options[i];
                    option.count = this.getCount(option.id);
                }
            }
            this.options = this.sortOptions(options);

        },
        getOptionName(id) {
            return this.$t("service_download."+this.facetId+"." + id);
        },
        getCount(id) {
            if (this.$store.state.resultFilter) {
                if (this.$store.state.resultFilter.facets_count) {
                    if (this.$store.state.resultFilter.facets_count[this.facetId]) {
                        let index = this.$store.state.resultFilter.facets_terms[this.facetId].indexOf(id);
                        return this.$store.state.resultFilter.facets_count[this.facetId][index]
                    }
                }
            }
            return 0;
        },
        updateSelection(e) {
            let selection = this.options.map((i) => {
                return i.selected ? i.id : null
            }).filter(i => i);
            //this.selection = selection;
            this.$emit('input', selection);
        },
        resetSelection() {
            this.options.forEach((i) => {
                i.selected = false;
            });
            this.updateSelection()
        },
    },
    watch: {
        options: {
            deep: true,
            handler() {

            }
        },
        facet(newVal, oldVal) {
            if (!newVal) {
                this.options = null;
            }
            this.buildOptions();
        },
        value(newVal) {}
    }

};
